export default function Welcome() {
  return (
    <h3 className="font-size22 color222 text-left font-semibold mb-c20">
      Welcome to Airbnb
    </h3>
  );
}
